import DashboardMain from "@/views/dashboard/DashboardMain";

export default [
    {
        path: '/dashboard',
        name: 'DashboardMain',
        meta: {layout: 'on-boarding',authRequired:true},
        component: DashboardMain,
    },
]